import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-4 py-1.5 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-4">
              {aboutContent.title}
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              专注吃瓜黑料，做最专业的黑料汇总平台
            </h2>
          </div>

          <div className="space-y-5">
            {aboutContent.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="flex flex-wrap gap-3 justify-center mt-8">
            {['极速追踪', '多方核验', '深度整理', '隐私保护'].map((tag) => (
              <span
                key={tag}
                className="px-4 py-2 bg-background-50 border border-background-200/60 rounded-lg text-sm text-foreground-600 font-medium whitespace-nowrap"
              >
                <i className="ri-check-line text-primary-500 mr-1.5"></i>
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}